import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';
import ProgramEditFaqsPage from '@/features/programs/program-edit-faqs/ProgramEditFaqsPage';
import {
  ProgramByIdFetchError,
  programByIdQueryOptions,
} from '@/features/programs/program-edit/program-by-id-query';

const editSearchSchema = z.object({
  copy: z.boolean().optional(),
});

export const programEditFaqsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/$programId/editar/perguntas-frequentes',
  component: ProgramEditFaqsPage,
  validateSearch: editSearchSchema,
  // RN-15: redirect to the listing when the program is missing (404) instead
  // of letting the page's useSuspenseQuery throw to the error boundary.
  loader: async ({ context, params }) => {
    try {
      await context.query.ensureQueryData(programByIdQueryOptions(params.programId));
    } catch (err) {
      if (err instanceof ProgramByIdFetchError && err.status === 404) {
        throw redirect({ to: '/programas', replace: true });
      }
      throw err;
    }
  },
});
